import type React from 'react';

import classNames from 'classnames';

import {TypographySize, useTypography} from '@time-webkit/all/hooks/typography';

import styles from './styles.module.css';

type Props = {
    error: React.ReactNode;
};

export const TextboxError = (props: Props) => {
    const bodyMCls = useTypography({
        size: TypographySize.BodyM,
        noDefaultColor: true,
    });

    if (!props.error) {
        return null;
    }

    return <div className={classNames(styles.container, bodyMCls)}>{props.error}</div>;
};
